if (!customElements.get('media-gallery') || !customElements.get('media-gallery-lite')) {
  (function($) {
    var $ = jQuery = $;
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.productGallery = this.querySelector(`.product-single__gallery-${this.dataset.section}`);
        this.thumbnailsWrapper = this.querySelector('.thumbnails-wrapper');
        this.productThumbnails = this.thumbnailsWrapper ? this.thumbnailsWrapper.querySelector('.product-single__thumbnails') : {};
        const productVariants = document.getElementById(`VariantSelect-${this.dataset.section}`);
        let options;
        let currentVariant;
        let mediaId = null;

        if (productVariants) {
          options = productVariants.productData ? productVariants.productData.options : null;
          currentVariant = productVariants.currentVariant;
          if (currentVariant && currentVariant.featured_media) {
            mediaId = `${this.dataset.section}-${currentVariant.featured_media.id}`;
          }
        }

        this.initBreakpoints();
        this.initGallerySlider();
        this.initThumbnails();
        this.initThumbnailSlider();
        this.setActiveMedia(mediaId, options, currentVariant);
      }

      initBreakpoints() {
        enquire.register('screen and (min-width: 1280px)', {
          match: () => {
            this.bpSmall = false;
          },
          unmatch: () => {
            this.bpSmall = true;
          }
        });

        enquire.register("screen and (min-width: 1001px)", {
          match : () => {
            this.blockSlide3DModel = true;
          }
        });
      }

      autoFitIsSupported() {
        const { userAgent } = window.navigator;

        if (userAgent.includes('Firefox/')) {
          return false;
        }

        return true;
      }

      initGallerySlider() {
        const self = this;
        const $productGallery = $(`.product-single__gallery-${this.dataset.section}`);
        const galleryInitialized = $productGallery.hasClass('slick-initialized');
        const optionsGallery = {
          arrows: true
        };
        if(galleryInitialized) return;

        $productGallery.on('init', function(event, slick){
          if (self.blockSlide3DModel === true) {
            const is3DModelActive = $productGallery.find('.slick-current .product-media-modal__model');
            if (is3DModelActive.length) {
              slick.slickSetOption('swipe', false);
            }
          }
        });

        $productGallery.slick(optionsGallery);

        $productGallery.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          self.setActiveThumbnail(null, nextSlide);
        });

        $productGallery.on('afterChange', function(event, slick, currentSlide){
          const activeMedia = $productGallery.find('.slick-current');
          if (activeMedia.length) {
            self.playActiveMedia(activeMedia[0]);
          }

          if (self.blockSlide3DModel === true) {
            const is3DModel = $productGallery.find('.slick-current .product-media-modal__model');

            if (is3DModel.length) {
              slick.slickSetOption('swipe', false);
            } else if (slick.slickGetOption('swipe') ===  false) {
              slick.slickSetOption('swipe', true);
            }
          }
        });


        // Accessibility concerns not yet fixed in Slick Slider
        $('.product-single__wrapper')
        .find('.slick-list')
        .removeAttr('aria-live');
        $('.product-single__wrapper')
        .find('.slick-disabled')
        .removeAttr('aria-disabled');
      }

    
      initThumbnailSlider() {
        const $thumbnailContainer = $(`.product-single__thumbnails-${this.dataset.section}`);
        
        // Get only truly visible items (not hidden by CSS or class)
        const $allItems = $thumbnailContainer.find('.product-single__thumbnails-item');
        const $visibleItems = $allItems.filter(function() {
          const $item = $(this);
          const isHidden = $item.hasClass('product-single__thumbnails--hide') || $item.css('display') === 'none';
          return !isHidden;
        });
        
        // console.log(`initThumbnailSlider: Found ${$allItems.length} total items, ${$visibleItems.length} visible items`);
        
        if ($visibleItems.length >= 1) {
          const thumbnailSliderOptions = {
            slidesToShow: Math.min(5, $visibleItems.length),
            slidesToScroll: 1,
            arrows: false, 
            infinite: false,
            vertical: false,
            focusOnSelect: false,
          };

          if (!$thumbnailContainer.hasClass('slick-initialized')) {
            $thumbnailContainer.slick(thumbnailSliderOptions);
            $thumbnailContainer.closest('.thumbnails-wrapper').addClass('has-thumbnail-slider');
            // console.log(`Slick initialized with ${thumbnailSliderOptions.slidesToShow} slides to show`);
          }
        } else {
          if ($thumbnailContainer.hasClass('slick-initialized')) {
            $thumbnailContainer.slick('unslick');
            $thumbnailContainer.closest('.thumbnails-wrapper').removeClass('has-thumbnail-slider');
          }
        }
      }

      initThumbnails() {
        const thumbImages = this.querySelectorAll(`.product-single__thumbnail--${this.dataset.section}`);
        if (!thumbImages.length) return;

        thumbImages.forEach((thumbImage) => {
          const self = this;

          thumbImage.addEventListener('click', function (e) {
            e.preventDefault();
            const mediaId = this.dataset.thumbnailId;
            self.setActiveThumbnail(mediaId);
          });
        });
      }

      setActiveThumbnail(mediaId = null, nextSlide = null) {
        let $activeThumbnail;
        let slideIndex = 0;
        const $thumbnailWrappers = $('.product-single__thumbnails-item');
        const $thumbnailActiveWrappers = $('.product-single__thumbnails-item:visible:not(.product-single__thumbnails--hide)');
        const $slickGallery = $(`.product-single__gallery-${this.dataset.section}`);
        const $thumbImages = $(`.product-single__thumbnail--${this.dataset.section}`);
        const $thumbnailContainer = $(`.product-single__thumbnails-${this.dataset.section}`);

        // Determine which thumbnail should be active
        if (!mediaId) {
          let activeSlide = $slickGallery.slick('slickCurrentSlide');

          if (nextSlide != null) {
            activeSlide = nextSlide;
          }

          $activeThumbnail = $($thumbnailActiveWrappers[activeSlide]).find('.product-single__thumbnail');
          if ($activeThumbnail.length) {
            mediaId = $activeThumbnail.data('thumbnail-id');
          }
        } else {
          $activeThumbnail = $thumbnailWrappers.find(
            `.product-single__thumbnail--${this.dataset.section}[data-thumbnail-id='${mediaId}']`
          );
        }

        $thumbImages
          .removeClass('active-thumb')
          .removeAttr('aria-current');

        // Add active class to current thumbnail
        $activeThumbnail.addClass('active-thumb');
        $activeThumbnail.attr('aria-current', true);

        // Find the correct slide index
        $thumbnailActiveWrappers.each(function (index, element) {
          const thumbnailId = $(element).find('.product-single__thumbnail').data('thumbnail-id');
          if (thumbnailId === mediaId) {
            slideIndex = index;
          }
        });

        // Update main gallery to show the correct slide
        $slickGallery.slick('slickGoTo', slideIndex, true);

        // AUTO-SCROLL THUMBNAIL SLIDER when active thumb is outside visible area
        if ($thumbnailContainer.hasClass('slick-initialized')) {
          const $activeThumbWrapper = $activeThumbnail.closest('.product-single__thumbnails-item');
          const activeThumbIndex = $thumbnailActiveWrappers.index($activeThumbWrapper);
          
          if (activeThumbIndex >= 0) {
            const slidesToShow = $thumbnailContainer.slick('slickGetOption', 'slidesToShow');
            const currentSlide = $thumbnailContainer.slick('slickCurrentSlide');
            const totalSlides = $thumbnailActiveWrappers.length;
            
            // Check if active thumbnail is outside the visible range
            const firstVisible = currentSlide;
            const lastVisible = currentSlide + slidesToShow - 1;
            
            // If active thumb is after the visible range, scroll forward
            if (activeThumbIndex > lastVisible) {
              const newSlide = Math.min(activeThumbIndex - slidesToShow + 1, totalSlides - slidesToShow);
              $thumbnailContainer.slick('slickGoTo', newSlide, false);
            }
            // If active thumb is before the visible range, scroll backward
            else if (activeThumbIndex < firstVisible) {
              $thumbnailContainer.slick('slickGoTo', activeThumbIndex, false);
            }
          }
        }
      }

      camelize(str) {
        return str.replace(/\W+(.)/g, function(match, chr) {
          return chr.toUpperCase();
        });
      }

      extractVariantFromAlt(altText) {
        if (!altText || typeof altText !== 'string') return null;
        
        const match = altText.match(/#([^-]+)--([^|\s]+)/);
        if (match) {
          return {
            optionName: match[1].trim().toLowerCase(),
            variantValue: match[2].trim()
          };
        }
        return null;
      }

      // Normalize variant value for comparison
      normalizeVariantValue(value) {
        if (!value) return '';
        // Remove spaces, special characters, convert to lowercase
        return value.toString().toLowerCase().replace(/[^a-z0-9]/g, '');
      }

     // Replace your setActiveMedia method with this fixed version
    // ROBUST SOLUTION - Replace your setActiveMedia method with this version

setActiveMedia(mediaId, productOptions, currentVariant) {
  const $slickGallery = $(`.product-single__gallery-${this.dataset.section}`);
  const $thumbnailContainer = $(`.product-single__thumbnails-${this.dataset.section}`);
  const $thumbnailWrapper = $thumbnailContainer.closest('.thumbnails-wrapper');
  const self = this;

  $('.product-single__thumbnails-item').removeClass('product-single__thumbnails--hide');
  
  if (productOptions && currentVariant) {
    // Build a map of current variant selections
    const variantSelections = {};
    productOptions.forEach((option, i) => {
      const optionName = option.toLowerCase().trim();
      const optionValue = currentVariant.options[i];
      
      // Only track Color and Finishes options
      if (optionName === 'color' || optionName === 'finishes') {
        variantSelections[optionName] = this.normalizeVariantValue(optionValue);
      }
    });

    // Check if any images have the new alt text format
    let hasValidAltTags = false;
    const $allThumbnails = $('.product-single__thumbnails-item');
    
    $allThumbnails.each((index, elem) => {
      const $img = $(elem).find('img');
      const alt = $img.data('alt') || $img.attr('data-alt') || $img.attr('alt');
      const variantInfo = this.extractVariantFromAlt(alt);
      if (variantInfo) {
        hasValidAltTags = true;
        return false; 
      }
    });

    if (hasValidAltTags) {
      // 1. Filter main gallery first
      $slickGallery.slick('slickUnfilter');
      $slickGallery.slick('slickFilter', function () {
        const altImage = $(this).attr('data-alt');
        const variantInfo = self.extractVariantFromAlt(altImage);

        if (!variantInfo) return true;

        const { optionName, variantValue } = variantInfo;
        const normalizedVariantValue = self.normalizeVariantValue(variantValue);
        
        return variantSelections[optionName] === normalizedVariantValue;
      });
      
      // 2. Ensure thumbnail slider is initialized
      const wasInitialized = $thumbnailContainer.hasClass('slick-initialized');
      
      if (!wasInitialized) {
        this.initThumbnailSlider();
        console.log('Initialized thumbnail slider');
      }
      
      // 3. Filter the thumbnail slider
      setTimeout(() => {
        if ($thumbnailContainer.hasClass('slick-initialized')) {
          $thumbnailContainer.slick('slickUnfilter');
          $thumbnailContainer.slick('slickFilter', function() {
            const $item = $(this);
            const $img = $item.find('img');
            const alt = $img.data('alt') || $img.attr('data-alt') || $img.attr('alt');
            const variantInfo = self.extractVariantFromAlt(alt);

            if (!variantInfo) return true;

            const { optionName, variantValue } = variantInfo;
            const normalizedVariantValue = self.normalizeVariantValue(variantValue);
            return variantSelections[optionName] === normalizedVariantValue;
          });
          
          $thumbnailContainer.slick('refresh');
          
          // 4. Count VISIBLE slides AFTER filtering (this is the key fix!)
          setTimeout(() => {
            const $visibleSlides = $thumbnailContainer
              .find('.slick-slide:not(.slick-cloned)')
              .filter(function() {
                return $(this).css('display') !== 'none';
              });
            
            const visibleCount = $visibleSlides.length;
            console.log(`Visible thumbnail slides after filter: ${visibleCount}`);
            
            // 5. Show/hide thumbnails based on ACTUAL visible count
            if (visibleCount <= 1) {
              console.log('Hiding thumbnail wrapper - only 1 or 0 visible');
              $thumbnailWrapper.hide();
            } else {
              console.log('Showing thumbnail wrapper - multiple visible');
              $thumbnailWrapper.show();
            }
            
            // 6. Set active thumbnail
            if (mediaId) {
              self.setActiveThumbnail(mediaId);
            }
          }, 50);
        }
      }, wasInitialized ? 0 : 150);

    } else {
      // No valid alt tags - show all images
      $thumbnailWrapper.show();
      
      if ($thumbnailContainer.hasClass('slick-initialized')) {
        $thumbnailContainer.slick('slickUnfilter');
        $thumbnailContainer.slick('refresh');
      } else {
        this.initThumbnailSlider();
      }

      if (mediaId) {
        setTimeout(() => {
          const activeMedia = this.productGallery.querySelector(`[data-media-id="${mediaId}"]`);
          if (activeMedia) {
            const slideIndex = parseInt(activeMedia.dataset.slickIndex);
            $slickGallery.slick('slickGoTo', slideIndex, true);
          }
        }, 100);
      }
    }

  } else {
    // No variant info - show all
    $thumbnailWrapper.show();
    
    if ($thumbnailContainer.hasClass('slick-initialized')) {
      $thumbnailContainer.slick('slickUnfilter');
      $thumbnailContainer.slick('refresh');
    } else {
      this.initThumbnailSlider();
    }

    if (mediaId) {
      setTimeout(() => {
        const activeMedia = this.productGallery.querySelector(`[data-media-id="${mediaId}"]`);
        if (activeMedia) {
          const slideIndex = parseInt(activeMedia.dataset.slickIndex);
          $slickGallery.slick('slickGoTo', slideIndex, true);
        }
      }, 100);
    }
  }

  // Play active media
  setTimeout(() => {
    const currentSlide = $slickGallery.slick('slickCurrentSlide');
    const activeMedia = this.productGallery.querySelector(`[data-slick-index="${currentSlide}"]`);
    this.playActiveMedia(activeMedia);
  }, 200);
}


      filterThumbnailSlider(variantSelections) {
        const $thumbnailContainer = $(`.product-single__thumbnails-${this.dataset.section}`);
        const self = this;
        
        if (!$thumbnailContainer.hasClass('slick-initialized')) {
          return;
        }

        
        
        $thumbnailContainer.slick('slickUnfilter');
        $thumbnailContainer.slick('slickFilter', function(index) {
          const $item = $(this);
          const $img = $item.find('img');
          const alt = $img.data('alt') || $img.attr('data-alt') || $img.attr('alt');
          const variantInfo = self.extractVariantFromAlt(alt);

          if (!variantInfo) {
            return true;
          }

          const { optionName, variantValue } = variantInfo;
          const normalizedVariantValue = self.normalizeVariantValue(variantValue);
          const shouldShow = variantSelections[optionName] === normalizedVariantValue;
          
          // console.log(`  Thumbnail ${index}: ${optionName}--${variantValue} → ${shouldShow ? 'SHOW' : 'HIDE'}`);
          return shouldShow;
        });
        
        $thumbnailContainer.slick('refresh');
        
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia(this);
        if (activeItem) {
          const video = activeItem.querySelector('video');

          if (video && video.getAttribute('autoplay')) {
            video.play();
          }

          const deferredMedia = activeItem.querySelector('.deferred-media:not(product-model)');
          if (deferredMedia && deferredMedia.dataset.preventAutoplay) return;
          if (deferredMedia && deferredMedia.loadContent) deferredMedia.loadContent(false);
        }
      }
    }

    customElements.define('media-gallery', MediaGallery);

    class MediaGalleryLite extends MediaGallery {
      constructor() {
        super();
      }

      initGallerySlider() {
        const self = this;
        const sectionId = this.dataset.section;
        const $productGallery = $(`.product-single__gallery-${sectionId}`);
        const $galleryNav = $(`.product-single__thumbnails-${sectionId}`);
        const optionsGallery = {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: `.product-single__thumbnails-${sectionId}`
        };
        const optionsNav = {
          slidesToShow: 3,
          slidesToScroll: 1,
          asNavFor: `.product-single__gallery-${sectionId}`,
          centerMode: true,
          centerPadding: '0px',
          focusOnSelect: true,
          vertical: true,
          arrows: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                vertical: false
              }
            }
          ]
        }

        $productGallery.on('init', function(event, slick){
          if (self.blockSlide3DModel === true) {
            const is3DModelActive = $productGallery.find('.slick-current .product-media-modal__model');
            if (is3DModelActive.length) {
              slick.slickSetOption('swipe', false);
            }
          }
        });

        $productGallery.slick(optionsGallery);
        $galleryNav.slick(optionsNav);

        $productGallery.on('beforeChange', function(event, slick, currentSlide, nextSlide){
          self.setActiveThumbnail(null, nextSlide);
        });

        $productGallery.on('afterChange', function(event, slick, currentSlide){
          const activeMedia = $productGallery.find('.slick-current');
          if (activeMedia.length) {
            self.playActiveMedia(activeMedia[0]);
          }

          if (self.blockSlide3DModel === true) {
            const is3DModel = $productGallery.find('.slick-current .product-media-modal__model');

            if (is3DModel.length) {
              slick.slickSetOption('swipe', false);
            } else if (slick.slickGetOption('swipe') ===  false) {
              slick.slickSetOption('swipe', true);
            }
          }
        });

        // Accessibility concerns not yet fixed in Slick Slider
        $('.product-single__wrapper')
        .find('.slick-list')
        .removeAttr('aria-live');
        $('.product-single__wrapper')
        .find('.slick-disabled')
        .removeAttr('aria-disabled');
      }
    }

    customElements.define('media-gallery-lite', MediaGalleryLite);
  })(theme.jQuery);
}